<template>
  <section>
    <h5 class="text-gray-800 fw-bold mb-3">Атрибуты документа</h5>
    <div class="mb-3">
      <span class="badge badge-secondary" v-html="item.typeName"></span> &nbsp;
      <span class="badge badge-secondary" v-html="item.item.filter.resident ? 'Резидент' : 'Нерезидент'"></span> &nbsp;
      <span class="badge badge-secondary" v-html="item.item.filter.person ? 'Физ. лицо' : 'Юр. лицо'"></span> &nbsp;
    </div>
    <div class="podft-list p-4 rounded border">
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Наименование</div>
        <div class="text-gray-800 fw-medium">{{item.item.client.title}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">ИИН/БИН</div>
        <div class="text-gray-800 fw-medium">{{item.item.client.iin}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Номер документа</div>
        <div class="text-gray-800 fw-medium">{{item.item.document.number}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Дата документа</div>
        <div class="text-gray-800 fw-medium">{{item.item.document.issued}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Дата рождения</div>
        <div class="text-gray-800 fw-medium">{{item.item.client.birthday}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">ID</div>
        <div class="text-gray-800 fw-medium">{{item.item.client.id}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Страна</div>
        <div class="text-gray-800 fw-medium">КАЗАХСТАН</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Адрес</div>
        <div class="text-gray-800 fw-medium">{{item.item.location.address}}</div>
      </div>
    </div>
  </section>
</template>

<script>
  import PodftAsideModalAppeal from "@/components/Podft/PodftAsideModal/PodftAsideModalAppeal.vue";

  export default {
    name: 'PodftAsideModalClient',
    components: {PodftAsideModalAppeal},
    props: {
      item: null
    },
    methods: { }
  }
</script>

<style scoped>

</style>